module.exports = __webpack_public_path__ + "static/Exo_Diagram_Part04_sprite-90-2ac4db139f151e0460dcd422325aef80.png";